var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.42,
    height: 15.229,
    viewBox: "0 0 17.42 15.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company",
    transform: "translate(-437.761 -373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "store_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M126.448-788.526V-790h15.3v1.474Zm.038,13.755v-5.9h-1.1v-1.474l1.058-4.912h15.3l1.058,4.912v1.474h-1.1v5.9h-1.474v-5.9h-4.421v5.9Zm1.474-1.474h6.386v-4.421h-6.386Zm-1.066-5.895h0Zm0,0h14.413l-.75-3.439H127.644l-.75,3.439Z",
    transform: "translate(312.371 1163)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyOutline);
export default __webpack_public_path__ + "static/media/Company_outline.5733ad1ad61c89734d1cce257faf6888.svg";
export { ForwardRef as ReactComponent };